import { desktopAssets, mobileAssets } from 'src/containers/PreCache'
import styled from 'styled-components'
import racingFlags from '../../../images/game/racing-flags.png'
import tyreIcon from '../../../images/game/tyre-icon.png'

const GameMobileLayout = styled.div`
  display: flex;
  flex-direction: column;
  --cyan: #70ecf4;
  --game-strokes: linear-gradient(269deg, #70ecf4 1.05%, #f7d9a5 51.61%, #70ecf4 99.27%);
  --bg-gradient: linear-gradient(299deg, #0f407b -12.8%, #70ecf4 106.16%);
  background-image: url('${mobileAssets.gameBgMobile}');
  background-attachment: fixed;
  background-size: 100% 100%;
  background-position: top;
  background-repeat: no-repeat;
  width: 100%;
  min-height: 100vh;
  color: white;
  padding: 20px;

  @media (min-width: 768px) {
    background-image: url('${desktopAssets.gameBg}');
  }

  .gradient-bg {
    background: linear-gradient(299deg, #0f407b -12.8%, #70ecf4 106.16%);
  }

  .gap-3 {
    gap: 12px;
  }

  .game-btn {
    cursor: pointer !important;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    appearance: none;
    outline: none;
    border: none;
    background: transparent;
    transition: all 0.2s ease-in-out;

    color: #fff;
    text-align: center;
    font-family: 'Venite Adoremus' !important;
    font-size: 1.25rem;
    font-style: italic;
    font-weight: 400;
    line-height: normal;

    &.blue {
      color: #052e68;

      svg {
        fill: inherit;
      }
    }

    &.start-game {
      font-size: 2.75rem;
      text-shadow: 0px 1px 14px var(--cyan);

      @media (min-width: 400px) {
        font-size: 3rem;
      }
    }

    &:hover {
      transform: translateY(-10%);
    }
    &:active {
      transform: scale(0.95);
    }
  }
`

const AlertCard = styled.fieldset`
  width: 100%;
  max-width: 744px;
  border-radius: 20px;
  border: 3px solid var(--cyan);
  backdrop-filter: blur(6px);
  padding: ${(props) => (props.answerBox ? '20px 20px 8px 20px' : '10px')};
  background: ${(props) => (props.answerBox ? 'rgba(255, 255, 255, 0.5)' : 'transparent')};
  min-height: ${(props) => (props.answerBox ? '310px' : '200px')};
  height: auto;
  overflow: visible;

  @media (min-width: 1140px) {
    max-width: 500px;
    min-height: ${(props) => (props.answerBox ? '409px' : '380px')};
    margin-top: ${(props) => (props.answerBox ? '-2%' : '0')};
    padding: 16px;
  }

  font-size: 0.875rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  legend {
    background: var(--game-strokes);
    padding: 2px;
    border-radius: 20px;
    width: auto;
    margin: 0 auto;
    width: 229px;
    height: auto;
    font-size: 1.25rem;

    @media (min-width: 1140px) {
      margin-top: -6% !important;
    }

    div {
      background: var(--bg-gradient);
      color: #ffffff;
      padding: 13px 21px;
      text-align: center;
      border-radius: 20px;
    }
  }

  .canvas {
    width: 100%;
    height: 180px;
    border: 2px dashed #ccc;
    border-radius: 10px;
    position: relative;
    transition: all 0.2s ease-in-out;

    @media (min-width: 1140px) {
      height: 266px;
    }
    &.drag-over {
      border-color: var(--cyan);
      background-color: rgba(112, 236, 244, 0.1);
      border-style: solid;
      box-shadow: inset 0 0 20px rgba(112, 236, 244, 0.3);
    }
  }

  .score {
    font-size: 4rem;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    margin-top: 24px;
    width: 100%;
    display: flex;
    max-width: 80%;
    padding: 4px 37px;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 7px;
    background: rgba(0, 0, 0, 0.46);
    text-align: center;
  }

  .correct {
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align: center;
  }

  .winner {
    h4 {
      font-size: 2rem;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
    p {
      font-size: 1rem;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }

  .answers-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0;
    justify-items: center;
    align-items: start;
    padding: 5px;
    width: 100%;
    box-sizing: border-box;
    overflow: visible;

    @media (min-width: 1140px) {
      gap: 8px;
    }
  }
`

const HeaderCard = styled.div`
  align-self: center;
  width: 100%;
  max-width: 744px;
  position: relative;
  border-radius: 20px;
  padding: 2px;
  background: var(--game-strokes);
  box-shadow: 0 -9px 43.5px -4px rgba(112, 236, 244, 0.91), 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  margin-block: 24px;

  @media (min-width: 1140px) {
    margin: 0 auto;
    margin-top: 24px;
    margin-bottom: 56px;
  }
  div {
    padding: 13px 21px;
    border-radius: 20px;
    background: linear-gradient(299deg, #0f407b -12.8%, #70ecf4 106.16%);
  }

  &:before {
    content: '';
    position: absolute;
    top: -20px;
    left: -7px;
    background: url('${racingFlags}');
    background-size: contain;
    background-repeat: no-repeat;
    width: 44px;
    height: 41px;
  }

  &:after {
    content: '';
    position: absolute;
    top: -20px;
    right: -7px;
    background: url('${racingFlags}');
    background-size: contain;
    background-repeat: no-repeat;
    width: 44px;
    height: 41px;
  }

  h1 {
    font-size: 1rem;
    font-weight: 900;
    line-height: normal;
    text-align: center;

    span {
      font-size: 1.875rem;
      font-weight: 400;
      line-height: normal;
      font-style: italic;
    }

    .question-number {
      font-size: 1.875rem;
      font-weight: 900;
      font-style: normal;
    }

    .total-questions {
      font-size: 1.25rem;
      font-weight: 900;
      font-style: normal;
    }

    .question-text {
      font-size: 1rem;
      font-weight: 900;
      line-height: normal;
      font-style: normal;
    }
  }

  .helper {
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align: center;
    margin: 0;
  }

  .font-venite {
    font-family: 'Venite Adoremus', sans-serif;
  }
`

const ScreenContainer = styled.div<{ isVisible: boolean }>`
  width: 100%;
  height: 100%;
  max-width: 1280px;
  margin: 0 auto;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 28px;
`

const Tyre = styled.div`
  width: 50px;
  height: 50px;
  background-image: url('${tyreIcon}');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
  cursor: grab;
  user-select: none;
  transition: all 0.2s ease-in-out;
  position: relative;
  flex-shrink: 0;

  /* Desktop size increase */
  @media (min-width: 1140px) {
    width: 70px;
    height: 70px;
  }

  /* Blue circle in center for letter */
  &::before {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    background: #0f407b;
    border-radius: 50%;
    z-index: 1;

    @media (min-width: 1140px) {
      width: 28px;
      height: 28px;
    }
  }

  .tyre-text {
    color: white;
    font-weight: bold;
    pointer-events: none;
    position: relative;
    z-index: 2;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
    font-size: 0.875rem;

    @media (min-width: 1140px) {
      font-size: 1.125rem;
    }
  }

  &:hover {
    transform: scale(1.05);
    filter: brightness(1.1);
  }

  &.dragging {
    opacity: 0.5;
    cursor: grabbing;
    transform: scale(0.9);
  }

  &.in-answer-box {
    opacity: 0.6;
    cursor: not-allowed;

    &:hover {
      transform: none;
      filter: none;
    }
  }

  &.dropped-tyre {
    cursor: pointer;

    &::before {
      background: var(--cyan);
      border-color: #0f407b;
    }

    .tyre-text {
      color: #0f407b;
      text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.5);
      font-weight: 900;
    }

    &:hover {
      transform: scale(1.1);
      filter: brightness(1.2);
    }
  }

  &.dragging-preview {
    &::before {
      background: var(--cyan);
      border-color: #0f407b;
    }

    .tyre-text {
      color: #0f407b;
      text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.5);
      font-weight: 900;
    }
  }
`

const StickyNote = styled.div`
  width: 100px;
  min-height: 75px;
  max-height: 130px;
  height: auto;
  background: #ffeb3b;
  border-radius: 2px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3), 0 2px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 0.6rem;
  font-weight: bold;
  cursor: grab;
  user-select: none;
  transition: all 0.2s ease-in-out;
  transform: rotate(-2deg);
  position: relative;
  padding: 4px;
  text-align: center;
  margin: 2px;

  &:nth-child(even) {
    transform: rotate(2deg);
  }

  &:nth-child(3n) {
    transform: rotate(-1deg);
  }

  &:nth-child(4n) {
    transform: rotate(3deg);
  }

  &:nth-child(5n) {
    transform: rotate(-3deg);
  }

  &:nth-child(6n) {
    transform: rotate(1deg);
  }

  &::before {
    content: '';
    position: absolute;
    top: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 10px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 20px;
  }

  .sticky-letter {
    font-size: 1rem;
    font-weight: 700;
    color: #333;
    margin-bottom: 4px;
    pointer-events: none;
  }

  .sticky-content {
    color: #333;
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1;
    pointer-events: none;
    word-wrap: break-word;
    hyphens: auto;
  }

  &:hover {
    transform: rotate(0deg) scale(1.05);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4), 0 4px 8px rgba(0, 0, 0, 0.3);
    z-index: 10;
  }

  &.dragging {
    opacity: 0.7;
    cursor: grabbing;
    transform: rotate(0deg) scale(0.95);
  }

  &.in-answer-box {
    opacity: 0.6;
    cursor: not-allowed;

    &:hover {
      transform: rotate(-2deg);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3), 0 2px 4px rgba(0, 0, 0, 0.2);
    }
  }

  &.dropped-sticky {
    cursor: pointer;
    border: 2px solid var(--cyan);

    &:hover {
      transform: rotate(0deg) scale(1.1);
      box-shadow: 0 8px 20px rgba(112, 236, 244, 0.4), 0 4px 12px rgba(112, 236, 244, 0.3);
    }
  }
`

const AnswerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin: 2px;
  min-height: 75px;
  max-height: 100px;
  height: auto;
  width: 85px;

  @media (min-width: 1140px) {
    max-height: 100%;
  }

  .answer-content {
    color: white;
    font-size: 0.75rem;
    font-weight: 600;
    text-align: center;
    line-height: 1;
    max-width: 80px;
    word-wrap: break-word;
    hyphens: auto;
  }
`

export { GameMobileLayout, HeaderCard, AlertCard, ScreenContainer, Tyre, StickyNote, AnswerContainer }
